import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOADigitalAssets() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ digitalAssets, setDigitalAssets ] = useState(powerOfAttorney.digital_assets || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../tangible-property');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      digital_assets: digitalAssets
    }));
    navigate('../business-operations');
  }, [ digitalAssets, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-digital-assets screen-container screen">
      <ScreenHeader
        title="Digital Assets"
        description="Decide whether to grant your agent power over your digital assets"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Digital Asset Powers?</h3>
        <p>
          Digital asset powers allow your agent to access and manage your online accounts 
          and digital property. This includes:
        </p>
        <ul className="digital-assets-list">
          <li>Online banking and financial accounts</li>
          <li>Email accounts and digital communications</li>
          <li>Social media accounts</li>
          <li>Cloud storage accounts (Google Drive, iCloud, etc.)</li>
          <li>Digital photos and documents</li>
          <li>Cryptocurrency and digital wallets</li>
          <li>Online business accounts</li>
          <li>Digital subscriptions and services</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Access your online accounts with proper authorization</li>
          <li>Manage digital files and documents</li>
          <li>Handle online financial transactions</li>
          <li>Preserve or delete digital content</li>
          <li>Transfer digital assets to beneficiaries</li>
          <li>Manage cryptocurrency holdings</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="digital-assets-yes"
            label="Yes"
            description="Grant power over digital assets"
            value="yes"
          />
          <AssetDistributionOption
            id="digital-assets-no"
            label="No"
            description="Do not grant power over digital assets"
            value="no"
          />
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            Digital asset access may require additional documentation and may be subject 
            to terms of service of individual platforms. Consider maintaining a separate 
            list of accounts and passwords for your agent.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
